module.exports = __webpack_public_path__ + "img/btg.fb5b6756.svg";